// extracted by mini-css-extract-plugin
export default {"root":"StableWidthMessage_root__z9zR7","visibleLabel":"StableWidthMessage_visibleLabel__DeRzu","ghostLabel":"StableWidthMessage_ghostLabel__rdSGg"};